module.exports = __webpack_public_path__ + "static/img/about_eileen_01_zh.64ab044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_eileen_01_zh.png
// module id = x+OO
// module chunks = 34